export interface TrackResponse {
    title: string;
    link: string;
    linkTitle: string;
    orders?: Order[];
    noOrdersText?: string;
    additionalTile?: AdditionalTile;
    noData?: boolean;
    noDataText?: string;
}

export interface AdditionalTile {
    title: string;
    link: string;
    linkText: string;
}

export interface Order {
    orderNumber: string;
    orderLink: string;
    orderLinkTitle: string;
    shipments: Shipment[];
}

export interface Shipment {
    title: string;
    status: ShipmentStatus;
    label: string;
    date: string;
    tracking: Tracking;
}

export interface ShipmentStatus {
    text: string;
    type: ShipmentStatusType;
}

export enum ShipmentStatusType {
    IN_PROGRESS = "in_progress",
    SENT = "sent",
    INVOICED = "invoiced"
}

export interface Tracking {
    number: string;
    link: string;
    linkTitle: string;
}
